import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { loginSelector } from "../../store/features/auth/authSlice";
import { BASE_IDENTITY_API_URL, IDENTITY_CLIENT_ID } from "../../../utils/constant";
import { IDENTITY_LOGIN_REDIRECT } from "../../../utils/services/apiPath";

const combineURL = (baseURL, ...segments) => {
  // Join the base URL and segments with '/'
  let url = [baseURL, ...segments].join('/');

  // Normalize the URL by removing any double slashes (except after the protocol)
  url = url.replace(/([^:]\/)\/+/g, '$1');

  return url;
}

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user } = useSelector(loginSelector);

  useEffect(() => {
    if (isAuthenticated && user) {
      if (location.state?.from) navigate(location.state.from.pathname + location.state.from.search, { replace: true });
      else if (user.isApprentice) navigate("/dashboard");
      else navigate("/wps-time-allocation");
    } else {
      const redirectUrl = new URL(combineURL(BASE_IDENTITY_API_URL, IDENTITY_LOGIN_REDIRECT));

      redirectUrl.searchParams.append("clientid", IDENTITY_CLIENT_ID);
      redirectUrl.searchParams.append("returnUrl", combineURL(window.location.origin, "identity-callback"));

      window.location.replace(redirectUrl.href);
    }
  }, [isAuthenticated, user, navigate, location]);

  return <></>;
};

export default Login;